import { render, staticRenderFns } from "./link-saved-checklist-panel.vue?vue&type=template&id=f16c63d2&"
import script from "./link-saved-checklist-panel.vue?vue&type=script&lang=ts&"
export * from "./link-saved-checklist-panel.vue?vue&type=script&lang=ts&"
import style0 from "./link-saved-checklist-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports